module.exports = __webpack_public_path__ + "img/news.339f31c.png";